import firestore from "../../firebase/firestore";
let couponRef = firestore.collection("coupons");

export const updateCouponField = (id, field, data) => {
  return new Promise((resolve, reject) => {
    var myCoupon = {};
    myCoupon[field] = data;
    let couponDoc = couponRef.doc(id);
    return couponDoc
      .update(myCoupon)
      .then(() => {
        return couponDoc
          .get()
          .then((doc) => {
            let coupon_data = {
              id: doc.id,
              ...doc.data(),
            };
            resolve(coupon_data);
          })
          .catch((err) => {
            console.error(err);
            reject(err);
          });
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      });
  });
};
